import ImagePlaceholder from "assets/icons/imagePlaceholder.svg"
import { ImageFragment } from "client/graphql/commerce-v2-api"
import {
  CarouselWrapper,
  ImageThumbnailButton,
  MAIN_IMAGE_HEIGHT,
  MainImage,
  THUMBNAIL_IMAGE_HEIGHT,
  Thumbnails,
  ViewGalleryCover,
} from "client/packages/commerce/components/product/ImageCarousel"
import useArrayElement from "shared/utils/useArrayElement"

export type TargetImageCarouselProps = {
  images: ImageFragment[]
  openImageGallery: (initialImgIndex?: number) => void
  thumbnailCount?: number
}

const TargetImageCarousel = ({
  images,
  openImageGallery,
  thumbnailCount = 4,
}: TargetImageCarouselProps) => {
  const [mainImage, { index: imgIndex, setIndex }] =
    useArrayElement(images)

  return (
    <CarouselWrapper>
      <MainImage>
        {mainImage?.url ? (
          <img
            width={MAIN_IMAGE_HEIGHT}
            height={MAIN_IMAGE_HEIGHT}
            alt={mainImage.altText ?? ""}
            src={mainImage.url}
          />
        ) : (
          <ImagePlaceholder />
        )}
      </MainImage>

      {images.length > 1 && (
        <Thumbnails>
          {images.map((image, index) => {
            if (index < thumbnailCount) {
              return (
                <ImageThumbnailButton
                  key={image.url}
                  type="button"
                  onClick={() => setIndex(index)}
                  $isSelected={index === imgIndex}
                >
                  <img
                    alt={image.altText ?? ""}
                    src={image.url}
                    height={THUMBNAIL_IMAGE_HEIGHT}
                    width={THUMBNAIL_IMAGE_HEIGHT}
                  />
                </ImageThumbnailButton>
              )
            }

            return null
          })}
          {images.length > thumbnailCount && (
            <ImageThumbnailButton
              key={images[thumbnailCount].altText}
              type="button"
              onClick={() => openImageGallery(thumbnailCount)}
              $isSelected={false}
            >
              <ViewGalleryCover>
                +{images.length - thumbnailCount}
              </ViewGalleryCover>
              <img
                height={THUMBNAIL_IMAGE_HEIGHT}
                width={THUMBNAIL_IMAGE_HEIGHT}
                alt="View Gallery"
                src={images[thumbnailCount].url}
              />
            </ImageThumbnailButton>
          )}
        </Thumbnails>
      )}
    </CarouselWrapper>
  )
}

export default TargetImageCarousel
